export default __webpack_public_path__ + "static/media/fridge2-afterA-768w.35746dc7.avif";